<template>
  <div class="con-wrap">
    <el-form
      size="medium"
      :inline="true"
      :model="queryForm"
      ref="queryForm"
      class="input-form-inline"
      @submit.native.prevent
    >
      <div>
        <el-form-item class="r-20" prop="vehicleModel">
          <el-input
            v-model="queryForm.vehicleModel"
            @keyup.enter.native="query"
            placeholder="车辆型号"
          ></el-input>
        </el-form-item>
        <el-form-item class="r-20" prop="deviceModel">
          <el-select v-model="queryForm.deviceModel" placeholder="设备型号">
            <el-option
              v-for="item in deviceModelList"
              :key="item.code"
              :label="item.value"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-button
          v-if="hasPerm('upgrade:package:list')"
          type="primary"
          @click="query"
          >查询</el-button
        >
        <el-button v-if="hasPerm('upgrade:package:list')" @click="reset"
          >取消</el-button
        >
      </div>

      <div style="margin-bottom: 20px">
        <el-button
          size="medium"
          v-if="hasPerm('upgrade:package:save')"
          type="primary"
          @click="uploadBtn"
          >上传</el-button
        >
        <el-button
          size="medium"
          v-if="hasPerm('upgrade:package:delete')"
          type="danger"
          @click="delUpgradePackage"
          >删除</el-button
        >
      </div>
    </el-form>
    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      size="mini"
      stripe
      height="560px"
      @row-click="handleClickTableRow"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        width="24"
        align="center"
        style="padding: 0"
      ></el-table-column>
      <el-table-column type="index" label="序号" width="55"></el-table-column>
      <el-table-column
        prop="vehicleModel"
        label="车辆型号"
        width="140"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="deviceModel" label="设备型号"></el-table-column>
      <el-table-column prop="type" label="升级包类型"></el-table-column>
      <el-table-column prop="softVer" label="软件版本号"></el-table-column>
      <el-table-column
        prop="hardVer"
        label="硬件版本号"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="fileName"
        label="文件名"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="md5"
        label="MD5"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="addTime"
        label="上传时间"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="操作" width="150" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            v-if="hasPerm('upgrade:package:list')"
            @click.stop="fileDownload(scope.row)"
            >文件下载</el-button
          >
          <el-button
            size="mini"
            type="text"
            v-if="hasPerm('upgrade:package:info')"
            @click.stop="details(scope.row)"
            >详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="limit"
      layout="total, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
    <!--上传升级包-->
    <el-dialog
      title="升级包上传"
      :visible.sync="packageUploadVisible"
      class="vehicle-dialog"
    >
      <el-form
        :rules="uploadRules"
        ref="uploadForm"
        :model="uploadForm"
        size="mini"
        :inline="true"
      >
        <div v-if="step == 1" id="first-step">
          <el-form-item prop="vehicleModelId" label="车辆型号">
            <el-select
              v-model="uploadForm.vehicleModelId"
              placeholder="请选择"
              @change="getVehicleModel"
            >
              <el-option
                v-for="item in modelList"
                :key="item.id"
                :label="item.vehicleModel"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="deviceModel" label="设备型号">
            <el-select
              v-model="uploadForm.deviceModel"
              placeholder="请选择设备型号"
            >
              <el-option
                v-for="item in deviceModelList"
                :key="item.code"
                :label="item.value"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="type" label="升级包类型">
            <el-select v-model="uploadForm.type" placeholder="请选择升级包类型">
              <el-option
                v-for="item in packageTypeList"
                :key="item.code"
                :label="item.value"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <div style="text-align:right">
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="nextStep">下一步</el-button>
            </span>
          </div>
        </div>
        <div v-else id="last-step">
          <el-form-item label="车辆型号" style="margin-bottom:0 !important">
            {{ vehicleModelName }}
          </el-form-item>
          <el-form-item label="设备型号" style="margin-bottom:0 !important">
            {{ deviceModelList[uploadForm.deviceModel - 1].value }}
          </el-form-item>
          <el-form-item label="升级包类型" style="margin-bottom:0 !important">
            {{ packageTypeList[uploadForm.type - 1].value }}
          </el-form-item>
          <el-form-item class="upload-box" label="文件名">
            <el-upload
              class="upload-demo"
              ref="upload"
              :with-credentials="true"
              :multiple="false"
              :limit="1"
              accept=".rar, .zip, .gz, .srec"
              :data="myData()"
              :file-list="fileList"
              :on-change="addFile"
              :action="uploadUrl()"
              :http-request="uploadSectionFile"
              :auto-upload="false"
            >
              <el-button
                size="small"
                type="primary"
                style="height: 28px;line-height:28px"
                >点击上传</el-button
              >
            </el-upload>
          </el-form-item>
          <el-form-item prop="md5" label="MD5校验">
            <el-input v-model="uploadForm.md5" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item prop="softVer" label="软件版本号">
            <el-input
              v-model="uploadForm.softVer"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item prop="hardVer" label="硬件版本号">
            <el-input
              v-model="uploadForm.hardVer"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item prop="summary" label="版本介绍">
            <el-input
              type="textarea"
              v-model="uploadForm.summary"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <div style="text-align:right">
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="importCommit">上传</el-button>
            </span>
          </div>
        </div>
      </el-form>
    </el-dialog>
    <!-- 详情弹窗 -->
    <el-dialog
      title="详情"
      :visible.sync="infoVisible"
      class="mini-dialog info-box"
    >
      <el-row :gutter="20">
        <el-col :span="7" class="dialog-label">车辆型号</el-col>
        <el-col :span="17">{{
          $judgeEmpty(upgradePackageInfo.vehicleModel)
        }}</el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="7" class="dialog-label">设备型号</el-col>
        <el-col :span="17">{{
          $judgeEmpty(upgradePackageInfo.deviceModel)
        }}</el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="7" class="dialog-label">升级包类型</el-col>
        <el-col :span="17">{{ $judgeEmpty(upgradePackageInfo.type) }}</el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="7" class="dialog-label">文件名</el-col>
        <el-col :span="17">{{
          $judgeEmpty(upgradePackageInfo.fileName)
        }}</el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="7" class="dialog-label">MD5校验</el-col>
        <el-col :span="17">{{ $judgeEmpty(upgradePackageInfo.md5) }}</el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="7" class="dialog-label">上传时间</el-col>
        <el-col :span="17">{{
          $judgeEmpty(upgradePackageInfo.addTime)
        }}</el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="7" class="dialog-label">软件版本号</el-col>
        <el-col :span="17">{{
          $judgeEmpty(upgradePackageInfo.softVer)
        }}</el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="7" class="dialog-label">硬件版本号</el-col>
        <el-col :span="17">{{
          $judgeEmpty(upgradePackageInfo.hardVer)
        }}</el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="7" class="dialog-label">版本简介</el-col>
        <el-col :span="17">{{
          $judgeEmpty(upgradePackageInfo.summary)
        }}</el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="infoVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      queryForm: {
        vehicleModel: "",
        deviceModel: "",
      },
      currentPage: 1,
      limit: 10,
      total: 0,
      tableVal: [],
      tableData: [],
      infoVisible: false,
      upgradePackageInfo: {},
      packageUploadVisible: false,
      modelList: [],
      deviceModelList: [],
      packageTypeList: [],
      uploadForm: {
        modelId: "",
      },
      step: 1,
      vehicleModelName: "",
      uploadRules: {
        vehicleModelId: [
          {
            required: true,
            trigger: "change",
            message: "请选择车辆型号",
          },
        ],
        deviceModel: [
          {
            required: true,
            trigger: "change",
            message: "请选择设备型号",
          },
        ],
        type: [
          {
            required: true,
            trigger: "change",
            message: "请选择升级包类型",
          },
        ],
        md5: [
          {
            required: true,
            trigger: "change",
            message: "请输入MD5校验码",
          },
        ],
        softVer: [
          {
            required: true,
            trigger: "change",
            message: "请输入软件版本",
          },
        ],
        hardVer: [
          {
            required: true,
            trigger: "change",
            message: "请输入硬件版本",
          },
        ],
      },
      fileList: [],
      fileSizeIsSatisfy: false,
    }
  },
  created() {
    this.getPackageList()
    this.getDeviceModelList()
  },
  methods: {
    async getPackageList() {
      let _this = this
      let obj = {}
      obj.vehicleModel = _this.queryForm.vehicleModel
      obj.deviceModel = _this.queryForm.deviceModel
      obj.limit = _this.limit
      obj.page = _this.currentPage
      let { data: res } = await _this.$axios.get("/api/upgrade/package/list", {
        params: obj,
      })
      if (res.code == 1) {
        _this.tableData = res.data.list
        _this.total = res.data.totalCount
      }
    },
    query() {
      this.getPackageList()
    },
    reset() {
      this.$resetForm(this, "queryForm")
      this.getPackageList()
    },
    async getModelList() {
      let _this = this
      let { data: res } = await _this.$axios.get("/api/vehicle/model/options")
      if (res.code == 1) {
        _this.modelList = res.data
      } else {
        _this.$message.warning(res.msg)
      }
    },
    async getDeviceModelList() {
      let _this = this
      let { data: res } = await _this.$axios.get(
        "/api/sys/dict/" + "deviceModel"
      )
      if (res.code == 1) {
        _this.deviceModelList = res.data
      } else {
        _this.$message.warning(res.msg)
      }
    },
    async getPackageTypeList() {
      let _this = this
      let { data: res } = await _this.$axios.get(
        "/api/sys/dict/" + "packageType"
      )
      if (res.code == 1) {
        _this.packageTypeList = res.data
      } else {
        _this.$message.warning(res.msg)
      }
    },
    //上传下一步车型回显
    getVehicleModel() {
      let id = this.uploadForm.vehicleModelId
      let list = this.modelList
      for (let s in list) {
        if (list[s].id == id) {
          this.vehicleModelName = list[s].vehicleModel
        }
      }
    },
    uploadBtn() {
      this.getModelList()
      //this.getDeviceModelList()
      this.getPackageTypeList()
      this.step = 1
      this.uploadForm = {}

      this.fileList = []
      this.packageUploadVisible = true
      this.$resetForm(this, "uploadForm")
    },
    nextStep() {
      this.$refs.uploadForm.validate(async (valid) => {
        if (valid) {
          this.step = 2
        }
      })
    },
    // 上传升级包-start-
    myData() {
      return {
        vehicleModelId: this.uploadForm.vehicleModelId,
        deviceModel: this.uploadForm.deviceModel,
        type: this.uploadForm.type,
        md5: this.uploadForm.md5,
        hardVer: this.uploadForm.hardVer,
        softVer: this.uploadForm.softVer,
        summary: this.uploadForm.summary,
      }
    },
    addFile(file, fileList) {
      this.fileList = fileList
      //限制上传文件为10M
      this.fileSizeIsSatisfy = file.size < 10 * 1024 * 1024 ? true : false
      this.extension = file.name.substring(file.name.lastIndexOf(".") + 1)
      console.log(file.type)
    },
    uploadUrl() {
      return "/api/upgrade/package/save"
    },
    async uploadSectionFile(parm) {
      let _this = this
      let fileObj = parm.file
      // FormData 对象
      let form = new FormData()
      // 文件对象
      form.append("file", fileObj)
      form.append("vehicleModelId", this.uploadForm.vehicleModelId)
      form.append("deviceModel", this.uploadForm.deviceModel)
      form.append("type", this.uploadForm.type)
      form.append("md5", this.uploadForm.md5)
      form.append("hardVer", this.uploadForm.hardVer)
      form.append("softVer", this.uploadForm.softVer)
      form.append("summary", this.uploadForm.summary)
      let { data: res } = await _this.$axios.post(
        "/api/upgrade/package/save",
        form
      )
      if (res.code == 1) {
        _this.$message.success("上传成功")
        _this.packageUploadVisible = false
        //导入成功后清空upload
        _this.$refs.upload.clearFiles()
        _this.fileList = []
        _this.getPackageList()
      } else {
        _this.$refs.upload.clearFiles()
        _this.fileList = []
        _this.$message.warning(res.msg)
      }
    },
    async importCommit() {
      console.log(this.myData())
      this.$refs.uploadForm.validate((valid) => {
        if (valid) {
          if (this.fileList.length <= 0) {
            this.$message.warning("请至少上传一个文件！")
            // console.log(this.uploadForm.type)
            return
          }
          //ARM升级包类型判断
          if (this.uploadForm.type == 2 && this.extension !== "gz") {
            this.$message.warning("请上传ARM升级包文件！")
            this.$refs.upload.clearFiles()
            this.fileList = []
            return
          }
          //MCU升级包类型判断
          if (this.uploadForm.type == 1 && this.extension !== "srec") {
            this.$message.warning("请上传MCU升级包文件！")
            this.$refs.upload.clearFiles()
            this.fileList = []
            return
          }

          if (!this.fileSizeIsSatisfy) {
            this.$message.warning("上传失败！文件大小超过10M！")
            this.$refs.upload.clearFiles()
            this.fileList = []
            return
          }
          this.$refs.upload.submit()
        }
      })
    },
    saveOrUpdate() {},
    delUpgradePackage() {
      let _this = this
      //多选删除
      let ids = _this.$getIds(_this.tableVal)
      if (!ids) {
        return
      }
      _this
        .$confirm("确定删除吗？", "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(async () => {
          let { data: res } = await _this.$axios.delete(
            "/api/upgrade/package",
            {
              data: JSON.stringify(ids),
            }
          )
          if (res.code == 1) {
            _this.$message.success("操作成功")
            let totalPage = Math.ceil((_this.total - 1) / 10)
            let currentPage =
              _this.currentPage > totalPage ? totalPage : _this.currentPage
            _this.currentPage = currentPage < 1 ? 1 : currentPage
            _this.getPackageList()
          } else {
            _this.$message.warning(res.msg)
          }
        })
    },
    fileDownload(rowData) {
      this.$confirm("确定下载该升级包吗？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        window.location.href = rowData.url
      })
    },
    async details(rowData) {
      let _this = this
      let { data: res } = await _this.$axios.get(
        "/api/upgrade/package/info/" + rowData.id
      )
      if (res.code == 1) {
        _this.upgradePackageInfo = res.data
        _this.upgradePackageInfo.vehicleModel = rowData.vehicleModel
        _this.infoVisible = true
      } else {
        _this.$message.warning(res.msg)
      }
    },
    //选择数据变化监控
    handleSelectionChange(val) {
      this.tableVal = val
    },
    handleClickTableRow(row, event, column) {
      console.log(row)
      console.log(column)
      this.$refs.multipleTable.toggleRowSelection(row)
    },
    //pagesize改变时触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    //页数改变时触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.currentPage = val
      this.getPackageList()
    },
  },
}
</script>

<style lang="scss" scoped>
.con-wrap {
  padding: 0 20px;
  background: #fff;
}
// 详情弹窗
.info-box /deep/ .el-dialog__body {
  color: #333;
}
.info-box /deep/ .el-dialog__body {
  padding-left: 40px;
}
.info-box /deep/ .el-dialog__footer {
  padding-top: 10px;
}
.dialog-label {
  padding-left: 20px;
  font-weight: bold;
}
.info-box /deep/ .el-row {
  height: 34px;
  line-height: 34px;
}
//升级包上传
.vehicle-dialog /deep/ .el-dialog {
  width: 600px;
}
.vehicle-dialog /deep/ .el-form-item__label {
  width: 140px;
  height: 32px;
  margin-left: 20px;
  text-align: left;
  color: #343434;
  font-size: 14px;
}
.vehicle-dialog /deep/ .el-form-item__content {
  width: 360px;
  height: auto;
}
.upload-box /deep/ .el-form-item__label {
  padding-left: 11px;
  position: relative;
}
.upload-box /deep/ .el-form-item__label::before {
  content: "*";
  color: #f56c6c;
  position: absolute;
  left: 0px;
  top: 1px;
}
</style>
